import { MenuItem as HeadlessMenuItem } from '@headlessui/react'

export const ItemDivider = () => {
    return (
        <HeadlessMenuItem disabled>
            <div className="mb-1.5 ml-3 mr-3 mt-1.5 h-px bg-neutral-200 dark:bg-neutral-700" />
        </HeadlessMenuItem>
    )
}
